/* @jsxRuntime automatic */
/* @jsxImportSource @superweb/css */

import { useIsMobile, useTypo, useUiColors } from "@superweb/ui";
import { useFlag } from "@superweb/flags";

import {
  CrossSeparator,
  YandexIntLogo,
  YandexLogo,
  YangoLogo,
} from "../images/logo";
import { useBrand } from "../router";

import { LanguageSelector } from "./language-selector";
import { MenuButton } from "./menu-button";
import { useProfile } from "../auth";

export const PageHeader = ({
  logoHeight,
  partnerName,
}: {
  logoHeight: number;
  partnerName?: string;
}) => {
  const flag = useFlag();
  const typo = useTypo();
  const brand = useBrand();
  const uiColors = useUiColors();
  const isMobile = useIsMobile();
  const { authentificationEnabled } = useProfile();

  const iconSize = isMobile ? "10px" : "20px";

  const yangoBrand = brand === "yango";
  const yandexRuLocation = /\.yandex\.ru$/.test(window.location.hostname);
  const enableMenuButton =
    authentificationEnabled ||
    flag({
      id: "4a4da9be-2617-4e1d-9c21-f6c32d0a0427",
      description: "Enable profile button without passport",
    });

  return (
    <header
      css={{
        display: "flex",
        justifyContent: "center",
        position: "relative",
        alignItems: "center",
        boxSizing: "border-box",
      }}
    >
      <div
        css={{
          color: uiColors.text,
          display: "grid",
          gridTemplateColumns: "auto 1fr",
          alignItems: "end",
        }}
      >
        <div
          css={{
            display: "grid",
            gridTemplateColumns: "auto auto 1fr",
            alignItems: "center",
          }}
        >
          <div
            css={{
              display: "flex",
              alignItems: "center",
              paddingInlineEnd: isMobile ? "6px" : yangoBrand ? "16px" : "20px",
              justifyContent: "end",
            }}
          >
            {yangoBrand ? (
              <YangoLogo height={logoHeight} width={isMobile ? 45 : 80} />
            ) : yandexRuLocation ? (
              <YandexLogo height={logoHeight} width={isMobile ? 83 : 163} />
            ) : (
              <YandexIntLogo height={logoHeight} width={isMobile ? 83 : 163} />
            )}
          </div>
          <CrossSeparator width={iconSize} height={iconSize} />
          <span
            css={{
              maxWidth: !isMobile ? "242px" : undefined,
              paddingInlineStart: isMobile ? "6px" : "16px",
              ...typo({
                level: isMobile ? "body2" : "title3",
                density: "normal",
                weight: "medium",
              }),
              ...(isMobile && enableMenuButton
                ? {
                    paddingBlockStart: "10px",
                    paddingBlockEnd: "10px",
                  }
                : {}),
            }}
          >
            {partnerName}
          </span>
        </div>
      </div>
      <div
        css={{
          position: "absolute",
          insetInlineEnd: "0",
          insetBlockStart: "2px",
        }}
      >
        {enableMenuButton ? (
          <MenuButton />
        ) : (
          <LanguageSelector view={isMobile ? "shortened" : "default"} />
        )}
      </div>
    </header>
  );
};
